export function isHTMLElement(x: unknown): x is HTMLElement {
  return x instanceof HTMLElement;
}

export function isSVGElement(x: unknown): x is SVGElement {
  return x instanceof SVGElement;
}
